import * as React from 'react';
import { IconProps } from '../types';

const IcCode = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='21' viewBox='0 0 22 21' fill='none' {...props}>
    <path
      d='M20.0664 0H1.93359C0.86741 0 0 0.86741 0 1.93359V18.457C0 19.5232 0.86741 20.3906 1.93359 20.3906H20.0664C21.1326 20.3906 22 19.5232 22 18.457V1.93359C22 0.86741 21.1326 0 20.0664 0ZM1.93359 1.28906H20.0664C20.4218 1.28906 20.7109 1.5782 20.7109 1.93359V5.15625H1.28906V1.93359C1.28906 1.5782 1.5782 1.28906 1.93359 1.28906ZM20.0664 19.1016H1.93359C1.5782 19.1016 1.28906 18.8124 1.28906 18.457V6.44531H20.7109V18.457C20.7109 18.8124 20.4218 19.1016 20.0664 19.1016Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M12.6969 8.99758C12.4431 8.88882 12.1491 9.00638 12.0404 9.26017L9.04056 16.26C8.93177 16.5138 9.04936 16.8077 9.30315 16.9165C9.55703 17.0253 9.85091 16.9076 9.95964 16.6539L12.9594 9.65409C13.0682 9.40027 12.9506 9.10634 12.6969 8.99758Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M7.90606 10.1447C7.75817 9.92906 7.48842 9.89412 7.30367 10.0666L5.16075 12.0666C4.94649 12.2665 4.94634 12.6474 5.16075 12.8475L7.30367 14.8474C7.48851 15.02 7.75826 14.985 7.90606 14.7694C8.05393 14.5537 8.02398 14.2391 7.83912 14.0666L6.11455 12.457L7.83912 10.8475C8.02398 10.675 8.05393 10.3604 7.90606 10.1447Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M16.8392 12.0666L14.6963 10.0666C14.5115 9.8941 14.2418 9.92907 14.0939 10.1447C13.9461 10.3603 13.976 10.675 14.1609 10.8475L15.8854 12.4571L14.1609 14.0666C13.976 14.2391 13.9461 14.5537 14.0939 14.7694C14.242 14.9852 14.5117 15.0198 14.6963 14.8474L16.8392 12.8475C17.0535 12.6476 17.0537 12.2667 16.8392 12.0666Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M3.26562 3.86719C3.62159 3.86719 3.91016 3.57862 3.91016 3.22266C3.91016 2.86669 3.62159 2.57812 3.26562 2.57812C2.90966 2.57812 2.62109 2.86669 2.62109 3.22266C2.62109 3.57862 2.90966 3.86719 3.26562 3.86719Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M5.84375 3.86719C6.19971 3.86719 6.48828 3.57862 6.48828 3.22266C6.48828 2.86669 6.19971 2.57812 5.84375 2.57812C5.48779 2.57812 5.19922 2.86669 5.19922 3.22266C5.19922 3.57862 5.48779 3.86719 5.84375 3.86719Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M8.42188 3.86719C8.77784 3.86719 9.06641 3.57862 9.06641 3.22266C9.06641 2.86669 8.77784 2.57812 8.42188 2.57812C8.06591 2.57812 7.77734 2.86669 7.77734 3.22266C7.77734 3.57862 8.06591 3.86719 8.42188 3.86719Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M14.8672 3.86719H18.7344C19.0903 3.86719 19.3789 3.57861 19.3789 3.22266C19.3789 2.8667 19.0903 2.57812 18.7344 2.57812H14.8672C14.5112 2.57812 14.2227 2.8667 14.2227 3.22266C14.2227 3.57861 14.5112 3.86719 14.8672 3.86719Z'
      fill={props?.fill ?? '#1D2129'}
    />
  </svg>
);

export default IcCode;
